import { render, staticRenderFns } from "./CookieBanner.vue?vue&type=template&id=8b3053e2&"
import script from "./CookieBanner.vue?vue&type=script&lang=js&"
export * from "./CookieBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/madamesumcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b3053e2')) {
      api.createRecord('8b3053e2', component.options)
    } else {
      api.reload('8b3053e2', component.options)
    }
    module.hot.accept("./CookieBanner.vue?vue&type=template&id=8b3053e2&", function () {
      api.rerender('8b3053e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/madamesum/js/components/CookieBanner.vue"
export default component.exports